import { Button, Heading, Link, Section } from 'components'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'

const TempCases = () => {
  const {
    allWpCase: { edges: cases },
  } = useStaticQuery(graphql`
    {
      allWpCase {
        edges {
          node {
            title
            featuredImage {
              node {
                id
                localFile {
                  childImageSharp {
                    id
                    fluid(quality: 70, maxWidth: 240, maxHeight: 240) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
            caseStudies {
              case {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <>
      <Section fullHeight>
        <div className="grid grid-cols-12 gap-24 items-center">
          <div className="space-y-6 col-span-6">
            <Heading type="kicker">Case Studies</Heading>
            <Heading>One Platform to rule them all</Heading>
            <p className="text-xl">
              The LeadBoxer platform is a mature, flexible solution which can be
              scaled to deliver a range of Lead & customer data solutions.
            </p>
          </div>
          <div className="overflow-hidden col-span-6">
            <div className="bg-gray-50 border border-gray-100 p-16 space-y-6">
              <div>
                <Heading level="3">Interested?</Heading>
              </div>
              <div>
                <p className="leading-loose">
                  Our experts are ready to solve your Lead & Customer
                  Intelligence challenge. Talk to us to get a free consultation
                  and trial account.
                </p>
              </div>
              <div>
                <Button type="primary" to="/demo">
                  Schedule a Demo
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Section>
      <Section>
        <div className="grid grid-cols-3 gap-16">
          {cases.map(({ node }, index) => (
            <div className="bg-gray-50 = rounded border border-gray-100">
              <Link to={node.caseStudies.case.localFile.publicURL}>
                <Img
                  fluid={
                    node.featuredImage.node.localFile.childImageSharp.fluid
                  }
                />
              </Link>
              <Heading level="4" className="px-4 pt-8">
                <Link to={node.caseStudies.case.localFile.publicURL}>
                  {node.title}
                </Link>
              </Heading>
            </div>
          ))}
        </div>
      </Section>
    </>
  )
}

export default TempCases
